import { useState } from 'react';
import Copyright from '../components/Copyright';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Logo } from '../components/Logo';
import { useParams, useHistory } from 'react-router-dom';
import { useUserContext } from '../context/UserContext';
import { userActionTypes } from '../app/enums';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Authentication } from '../api/api';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    container: {
      padding: 25,
    },
    paper: { 
      padding: 25,
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', 
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }),
);

export const ResetPassword = () => {
  const history = useHistory();
  const classes = useStyles();
  const { dispatch } = useUserContext();
  const { token } = useParams<{ token: string }>();
  const [ newPassword, setNewPassword ] = useState<string>('')
  const [ confirmPassword, setConfirmPassword ] = useState<string>('')
  const [ confirmError, setConfirmError ] = useState<string>('');
  const [ resetError, setResetError ] = useState<string>('');
  let refreshToken = '';

  const validate = () => {
    if(newPassword !== confirmPassword)
      setConfirmError('Password and Confirm Password must match')
    else
      setConfirmError('')
  } 

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();
    validate();
    setResetError('')
    
    if(confirmError.length > 0)
      return;

    Authentication.resetPassword(token, newPassword)
      .then((login) => {   
        if(login.refreshToken.length > 0){
          refreshToken = login.refreshToken     
          dispatch({ type: userActionTypes.LOGIN_USER, user: login })
        }

        history.push('/search');
      })
      .catch((error) => {
        setResetError(error);
      })
  };

  return (
    <Container component="main" maxWidth="xs" className={classes.container}> 
      <Paper className={classes.container} elevation={3}>
        <div className={classes.paper}>
          <Logo />
          <form className={classes.form} onSubmit={handleSubmit}>
          { resetError &&
            <Alert severity="error" >
              <AlertTitle>Error</AlertTitle>
              {resetError}
            </Alert>   
          }
          <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="newPassword"
              label="Password"
              type="password"
              id="newPassword"
              onChange={(e) => setNewPassword(e.target.value)}
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              id="confirmPassword"
              onChange={(e) => setConfirmPassword(e.target.value)}
              onBlur={() => validate()}
              error={confirmError.length > 0}
              helperText={confirmError}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Change Password
            </Button>
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
